export default "__VITE_ASSET__CMlqbCiL__"